/**
 * Theme tokens based on Dashboard design system
 * Provides mode-aware (dark/light) token system
 */

import type { DashboardMode } from "@/components/dashboard/DashboardThemeProvider";
import { getDashboardTheme } from "@/components/dashboard/theme";

/**
 * Get theme tokens for a specific mode
 * @param mode - 'dark' | 'light'
 * @returns Theme tokens object
 */
export const getThemeTokens = (mode: DashboardMode) => {
  return getDashboardTheme(mode);
};

/**
 * Type for theme tokens
 */
export type ThemeTokens = ReturnType<typeof getDashboardTheme>;

/**
 * Common spacing values (aligned with Chakra)
 */
export const spacing = {
  xs: "0.5rem", // 8px
  sm: "0.75rem", // 12px
  md: "1rem", // 16px
  lg: "1.5rem", // 24px
  xl: "2rem", // 32px
  "2xl": "3rem", // 48px
} as const;

/**
 * Border radius values
 */
export const borderRadius = {
  sm: "4px",
  md: "8px",
  lg: "12px",
  xl: "16px",
  full: "9999px",
} as const;

/**
 * Transition durations
 */
export const transitions = {
  fast: "0.15s",
  normal: "0.18s",
  slow: "0.3s",
} as const;

/**
 * Transition easing
 */
export const easing = {
  easeOut: "ease-out",
  easeIn: "ease-in",
  easeInOut: "ease-in-out",
} as const;

